export default "__VITE_ASSET__DDi5eNNH__"